/**
 * Animação em que o cartão do convite (título e link, na tela até o primeiro convidado entrar)
 * encolhe e "pousa" no botão de compartilhar da barra, que dá uma pulsada ao receber o cartão.
 * Sem Web Animations, com movimento reduzido ou sem o botão de destino, termina na hora.
 */

export const INVITE_FLIGHT_MS = 650;
const CONTENT_FADE_MS = 180;
const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

const prefersReducedMotion = () =>
    typeof window !== 'undefined' && Boolean(window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches);

/** Deslocamento e escala que levam o centro do cartão ao centro do botão. */
export function flightTransform(from, to) {
    const dx = to.left + to.width / 2 - (from.left + from.width / 2);
    const dy = to.top + to.height / 2 - (from.top + from.height / 2);
    return { dx, dy, sx: to.width / from.width, sy: to.height / from.height };
}

/**
 * @param {{ card: HTMLElement | null, content?: HTMLElement | null, target: HTMLElement | null, onDone: () => void }} args
 * @returns {() => void} cancela a animação em andamento (ex.: a sala fechou no meio dela)
 */
export function playInviteLanding({ card, content, target, onDone }) {
    const from = card?.getBoundingClientRect?.();
    const to = target?.getBoundingClientRect?.();
    const canFly = typeof card?.animate === 'function' && from?.width > 0 && from?.height > 0 && to?.width > 0
        && !prefersReducedMotion();
    if (!canFly) {
        onDone();
        return () => {};
    }

    const { dx, dy, sx, sy } = flightTransform(from, to);
    // O texto some antes de a caixa se achatar, para não aparecer espremido.
    content?.animate?.([{ opacity: 1 }, { opacity: 0 }], { duration: CONTENT_FADE_MS, fill: 'forwards' });
    // O cartão é escuro como a barra: no caminho ele ganha o ciano do botão para ser visto até pousar, e só
    // no fim apaga, deixando o botão de verdade (e a pulsada) no lugar.
    const landed = `translate(${dx}px, ${dy}px) scale(${sx}, ${sy})`;
    const flight = card.animate(
        [
            { transform: 'translate(0, 0) scale(1, 1)', opacity: 1, borderRadius: '24px', backgroundColor: 'rgb(23, 23, 23)' },
            { transform: landed, opacity: 1, borderRadius: '9999px', backgroundColor: 'rgb(34, 211, 238)', offset: 0.85 },
            { transform: landed, opacity: 0, borderRadius: '9999px', backgroundColor: 'rgb(34, 211, 238)' },
        ],
        { duration: INVITE_FLIGHT_MS, easing: EASING, fill: 'forwards' },
    );
    flight.onfinish = () => {
        target.animate?.(
            [
                { transform: 'scale(1)', boxShadow: '0 0 0 0 rgba(34, 211, 238, 0.7)' },
                { transform: 'scale(1.15)', boxShadow: '0 0 0 12px rgba(34, 211, 238, 0)', offset: 0.6 },
                { transform: 'scale(1)', boxShadow: '0 0 0 0 rgba(34, 211, 238, 0)' },
            ],
            { duration: 700, easing: EASING },
        );
        onDone();
    };
    return () => flight.cancel();
}
